const LocalizationAssistant_RegExp = new RegExp(
  '~(([a-zA-Z0-9_]+)(::([a-zA-Z0-9_]+))?)~',
  'g'
);

export function LocalizationAssistant_Parse(element) {
  [].forEach.call(element.childNodes, function(childNode) {
    if (childNode.nodeType === 3) LocalizationAssistant_Process(childNode);
    else LocalizationAssistant_Parse(childNode);
  });
}

function LocalizationAssistant_Process(textNode) {
  var matches = LocalizationAssistant_RegExp.exec(textNode.textContent);
  if (matches) {
    // exception for some elements, e.g. <option>
    if (
      textNode.parentElement !== null &&
      textNode.parentElement.nodeName.toLowerCase() === 'option'
    )
      textNode.textContent = textNode.textContent.replace(
        LocalizationAssistant_RegExp,
        ' #' + matches[1]
      );
    else {
      var wrapperElement = document.createElement('div');
      wrapperElement.className = 'localization-assistant-wrapper';
      var innerElement = document.createElement('div');
      innerElement.innerText = '#';
      innerElement.className = 'localization-assistant';
      innerElement.setAttribute('title', matches[1]);
      innerElement.setAttribute('localization-assistant-key', matches[1]);
      innerElement.setAttribute('localization-assistant-namespace', matches[2]);
      innerElement.setAttribute('localization-assistant-id', matches[4]);
      innerElement.addEventListener(
        'click',
        function() {
          var url = window.LocalizationAssistant_Url;
          if (url) {
            url = url.replace(
              '{key}',
              encodeURIComponent(
                this.getAttribute('localization-assistant-key')
              )
            );
            url = url.replace('{locale}', encodeURIComponent(window.locale));
            window.open(url, '_blank');
          }
        },
        false
      );
      wrapperElement.appendChild(innerElement);
      if (textNode.nextSibling)
        textNode.parentNode.insertBefore(wrapperElement, textNode.nextSibling);
      else textNode.parentNode.appendChild(wrapperElement);
      textNode.textContent = textNode.textContent.replace(
        LocalizationAssistant_RegExp,
        ''
      );
    }
  }
}

export function LocalizationAssistant_MutationObserver_Callback(
  mutationList,
  observer
) {
  mutationList.forEach(mutation => {
    switch (mutation.type) {
      case 'childList':
        if (mutation.target) LocalizationAssistant_Parse(mutation.target);
        break;
      case 'attributes':
        if (mutation.target) LocalizationAssistant_Parse(mutation.target);
        break;
      case 'characterData':
        if (mutation.target) LocalizationAssistant_Process(mutation.target);
        break;
      default:
        break;
    }
  });
}



// WEBPACK FOOTER //
// ./src/app/components/Localization/LocalizationAssistant.js